import { render, staticRenderFns } from "./MyAttempts.vue?vue&type=template&id=8b67ed7e&"
import script from "./MyAttempts.vue?vue&type=script&lang=js&"
export * from "./MyAttempts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports